import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ApprovalsService } from '../approvals.service';
import { RxComponent } from "../../../../core/components/common/rx.component";
import { SmartModalService } from '../../../../core/services/smart-modal.service';

@Component({
    selector: 'itpx-create-approval-rule',
    templateUrl: './create-approval-rule.component.html',
    styleUrls: ['./create-approval-rule.component.css']
})
export class CreateApprovalRuleComponent extends RxComponent implements OnInit {

    @Input() data: any = null;

    public ruleDetails = null;

    public fetchedGroups = [];
    public ruleOperators = [];
    public ruleTypes = [];
    public currency = null;

    public allSubscriptions: Array<Subscription> = [];

    public formGroup: FormGroup;
    public newRule: boolean = false;
    public buyerCurrency: any = null;
    public errorMsg: any = false;
    public errorMsgExist: any = false;
    public errorMessage: any;

    constructor(
        private approvalsService: ApprovalsService,
        private modalService: SmartModalService,
        public fb: FormBuilder
    ) {
        super();
    }

    ngOnInit(): void {
        super.ngOnInit();

        this.ruleDetails = this.data.ruleItem;
        this.newRule = this.data.newRule;
        this.buyerCurrency = this.data.buyerCurrency;

        this.initForm();

        this.formGroup.patchValue({
            name: this.ruleDetails && this.ruleDetails.name,
            type: this.ruleDetails && this.ruleDetails.type.id,
            transMin: this.ruleDetails && this.ruleDetails.rules[0].value[0],
            transMax: this.ruleDetails && this.ruleDetails.rules[0].value[0],
            group: this.ruleDetails && this.ruleDetails.approvalGroup.id
                ? [this.ruleDetails.approvalGroup.id]
                : []
        });

        this.fetchOtherData();
    }

    fetchOtherData() {
        this.approvalsService.fetchApprovalGroups()
            .map(data => data.map(_ => { return { key: _.id, value: _.groupName } }))
            .subscribe(_ => this.fetchedGroups = _);

        this.approvalsService.fetchRuleOperatorTypes()
            .subscribe(_ => this.ruleOperators = _);

        this.approvalsService.fetchRuleType()
            .subscribe(_ => this.ruleTypes = _);
    }

    isFormValid(): boolean {
        return this.formGroup.valid
            && this.formGroup.get('group').value
            && (this.isNotConsumptionRequest(this.formGroup.get('type').value) ? this.formGroup.get('transMin').value < this.formGroup.get('transMax').value : true);
    }

    areThresholdsInvalid(): boolean {
        return this.formGroup.get('transMin').value > 0 &&
            this.formGroup.get('transMax').value > 0 &&
            this.formGroup.get('transMin').value > this.formGroup.get('transMax').value;
    }

    saveApprovalRule() {
        let payload: any = {
            name: this.formGroup.get('name').value,
            type: {
                id: this.formGroup.get('type').value
            },
            currency: {
                configKey: this.buyerCurrency
            },
            approvalGroup: {
                id: this.formGroup.get('group').value
            },
            rules: this.isNotConsumptionRequest(this.formGroup.get('type').value)
                ? [
                    {
                        operator: { id: this.ruleOperators.filter(_ => _.value === 'range')[0].key },
                        value: [
                            this.formGroup.get('transMin').value.toString(),
                            this.formGroup.get('transMax').value.toString()
                        ]
                    }
                ]
                : []
        };
        if (!this.newRule) {
            payload.id = this.ruleDetails.id;//editApprovalRule

            this.approvalsService.editApprovalRule(payload).subscribe(_ => {
                this.modalService.sendResult('Approval rule updated');
            });

        }
        else {
            this.allSubscriptions.push(
                this.approvalsService.saveApprovalRule(payload).subscribe(
                    _ => {
                        this.errorMsg = false;
                        this.errorMessage = "";
                        this.modalService.sendResult('Approval rule created');
                    },
                    error => {
                        this.errorMsg = true
                        this.errorMessage = JSON.parse(error._body).error.message;
                    }
                )
            );
        }

    }

    isTypeSelected(): boolean {
        return this.formGroup && this.formGroup.get('type') && this.formGroup.get('type').value;
    }

    isNotConsumptionRequest(type: string): boolean {
        return this.isTypeSelected()
            && !!this.ruleTypes.find(ruleType => ruleType.key === type && ruleType.value !== 'Consumption Request');
    }

    cancelSaving() {
        this.modalService.sendResult(null);
    }

    private initForm() {
        this.formGroup = this.fb.group({
            name: [null, [Validators.required]],
            type: [null, [Validators.required]],
            transMin: [null, [Validators.required]],
            transMax: [null, [Validators.required]],
            group: [null, [Validators.required]],
        });

        this.formGroup.get('type').valueChanges
            .bindToLifecycle(this)
            .subscribe((value: string) => {
                if (this.isNotConsumptionRequest(value)) {
                    this.formGroup.get('transMin').enable();
                    this.formGroup.get('transMax').enable();
                } else {
                    this.formGroup.get('transMin').disable();
                    this.formGroup.get('transMax').disable();
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/organization/components/approvals/create-approval-rule/create-approval-rule.component.ts